var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5a4.25 4.25 0 0 1 4.25-4.25h25.5A4.25 4.25 0 0 1 34 8.5v17a4.25 4.25 0 0 1-4.25 4.25H4.25A4.25 4.25 0 0 1 0 25.5v-17Zm4.25-2.125A2.125 2.125 0 0 0 2.125 8.5v.461L17 17.886l14.875-8.925V8.5a2.125 2.125 0 0 0-2.125-2.125H4.25Zm27.625 5.064-10.11 6.067 10.11 6.111V11.44Zm-.072 14.616L19.7 18.742 17 20.364l-2.703-1.622-12.1 7.31a2.125 2.125 0 0 0 2.053 1.573h25.5a2.126 2.126 0 0 0 2.053-1.57ZM2.125 23.617l10.11-6.111-10.11-6.067v12.178Z",
    fill: "#2C112D"
  })));
};
export default SvgEmail;